import { CommonSectionIds } from '../common.models';

export const EchoSectionIds = {
    BasicInfo: CommonSectionIds.BasicInfo,
    ConfigureAlarms: CommonSectionIds.ConfigureAlarms,
    DataDelivery: CommonSectionIds.DataDelivery,
    Advanced: CommonSectionIds.Advanced,
    DialogActions: CommonSectionIds.DialogActions,
    EchoInfo: 'echo-info-section',
};

export enum EchoInfoFieldIds {
    StoreTemperature = 'echo-info-storetemperature',
    BatteryVoltage = 'echo-info-batteryvoltage',
    Sensor = 'echo-info-sensor',
    Silt = 'echo-info-silt',
    SiltEditButton = 'echo-info-silt-edit-button',
    HcValue = 'echo-info-hcValue',
}

export enum LongRangeFieldIds {
    ManholeDepth = 'long-range-echo-manholedepth',
    PhysicalOffset = 'long-range-echo-physicalOffset',
    StoreData = 'long-range-echo-storeData',
    Blanking = 'long-range-echo-blanking',
    TemperatureSensor = 'long-range-echo-temperatureSensor',
    Power = 'long-range-echo-power',
    ElectronicOffset = 'long-range-echo-electronicOffset',
    GainControlSelection = 'long-range-echo-gainControlSelection',
    GainControl = 'long-range-echo-gainControl',
    UnidepthFiltering = 'long-range-echo-unidepthFiltering',
    PressureStore = 'long-range-echo-pressureStore',
    CompensatedTemperatureMarch = 'long-range-echo-compensatedTemperatureMarch',
    CompensatedTemperatureSeptember = 'long-range-echo-compensatedTemperatureSeptember',
}

export enum EchoAlarmFieldIds {
    tiltEnable = 'echo-tilt-enable',
    tiltThreshold = 'echo-tilt-threshold',
    UnidepthToAverage = 'echo-unidepthtoaverage',
}

export const ECHO_MONITOR_CONFIGURATION_CONSTANTS = {
    ftpdeliverynormal: 0,
    ftpdeliveryfast: 0,
    ftpfolder: '',
    ftppassword: '',
    ftpusername: '',
    ftpserver: '',
    ftpmode: 'Active',
    ftpformat: 'ADS',
    storetemperature: false,
    storebattery: 1,
}
